import {
  getNextBillingCycleDate,
  getRoundedPriceWithCurrency,
} from 'src/utils';
import styles from './SummaryContent.module.scss';
import { SummaryRow } from '../SummaryRow';
import { CanonicalInterval, SubscriptionPlanInfo } from 'src/types';
import { ProgressBar } from 'src/components/FlatAppearance/components/ThreadCombinedCard/components/ProgressBar';
import { convertTierName } from 'src/utils/user';

interface SummaryContentProps {
  selectedPlan?: SubscriptionPlanInfo;
  subtotal: number;
  taxes: number;
  discount?: number;
  totalOriginalAmount: number;
  dueToday: number;
  isTeams?: boolean;
  seats?: number | null;
  isLoading?: boolean;
}

export const SummaryContent = ({
  selectedPlan,
  subtotal,
  taxes,
  discount,
  totalOriginalAmount,
  dueToday,
  isTeams,
  seats,
  isLoading = false,
}: SummaryContentProps) => {
  const planName = convertTierName(selectedPlan?.plan_tier || '');
  const planPeriod =
    selectedPlan?.period === CanonicalInterval.ANNUALLY ? 'annual' : 'monthly';
  return (
    <div className={styles.content}>
      <div className={styles.checkoutResultSection}>
        <div className={styles.checkoutResultSectionRow}>
          <span className={styles.subscriptionRow}>
            {planName} {planPeriod} subscription
          </span>
          {isLoading ? (
            <ProgressBar
              progressLineClassName={styles.priceLoaderLine}
              className={styles.priceLoader}
            />
          ) : (
            <span>
              {getRoundedPriceWithCurrency(totalOriginalAmount)}/
              {selectedPlan?.period === CanonicalInterval.MONTHLY ? 'mo' : 'yr'}
            </span>
          )}
        </div>
      </div>

      {!!seats && (
        <div className={styles.checkoutResultSection}>
          <div className={styles.checkoutResultSectionRow}>
            <span className={styles.subscriptionRow}>Seats</span>
            <span>{seats}</span>
          </div>
        </div>
      )}

      <hr className={`divider ${!!seats ? '' : 'no-margin'}`} />

      <div className={styles.checkoutRowWrapper}>
        <SummaryRow
          label="Subtotal"
          value={getRoundedPriceWithCurrency(subtotal)}
          isLoading={isLoading}
        />
        {!!discount && (
          <SummaryRow
            label="Discount"
            value={`-${getRoundedPriceWithCurrency(discount)}`}
            isLoading={isLoading}
          />
        )}
        <SummaryRow
          label="Tax & fees"
          value={getRoundedPriceWithCurrency(taxes)}
          isLoading={isLoading}
        />

        <div className={styles.checkoutResultSectionRow}>
          <span>Due today (USD)</span>

          {isLoading ? (
            <ProgressBar
              progressLineClassName={styles.priceLoaderLine}
              className={styles.priceLoader}
            />
          ) : (
            <span>{getRoundedPriceWithCurrency(dueToday)}</span>
          )}
        </div>

        {isTeams && !!seats && (
          <span className={styles.teamDescription}>
            Then{' '}
            {getRoundedPriceWithCurrency(
              selectedPlan?.total_recurring_amount || 0,
            )}{' '}
            per {selectedPlan?.period === 'monthly' ? 'month' : 'year'}
            {getNextBillingCycleDate(
              selectedPlan?.next_billing_cycle_start_timestamp,
            )}
          </span>
        )}
      </div>
    </div>
  );
};
